module.exports = __webpack_public_path__ + "img/icon-生物@2x.c4e9a18a.png";